export default __webpack_public_path__ + "static/media/Uiadd.2013f005.svg";